import axios from 'axios'
import CreateKvkk from './dto/CreateKvkk'
import GetKvkk from './dto/GetKvkk'
import UpdateKvkk from './dto/UpdateKvkk'
import { EntityDto } from '../../../../../services/dto/entityDto'

const API_URL = process.env.REACT_APP_SERVICE_API_URL
export const URL_CREATE = `${API_URL}/Kvkk/Create`
export const URL_GET = `${API_URL}/Kvkk/Get`
export const URL_UPDATE = `${API_URL}/Kvkk/Update`

export function onCreateKvkk(createKvkk: CreateKvkk): Promise<boolean> {
  return axios.post(URL_CREATE, createKvkk)
}

export function onGetKvkk(kvkkTypeId: EntityDto): Promise<GetKvkk> {
  return axios.get(URL_GET, {params: kvkkTypeId})
}

export function onUpdateKvkk(updateKvkkInput: UpdateKvkk): Promise<boolean> {
  return axios.put(URL_UPDATE, updateKvkkInput)
}
